import {v4 as uuidv4} from 'uuid'
import {get, set} from 'lodash'

export default {
    setEventData(state, eventData) {
        state.eventData = {...(state.eventData), ...eventData}
    },

    setRemainingPlaces(state, remainingPlaces) {
        state.remainingPlaces = remainingPlaces
    },

    setAvailabilities(state, availabilities) {
        state.availabilities = availabilities
    },

    setReservedPlaces(state, reservedPlaces) {
        state.reservedPlaces = reservedPlaces
    },

    setReservedAvailabilities(state, reservedAvailabilities) {
        state.reservedAvailabilities = reservedAvailabilities
    },

    setOccupancy(state, occupancy) {
        state.occupancy = occupancy
    },

    setRegistrationData(state, registrationData) {
        state.registrationData = {...(state.registrationData), ...registrationData}
    },

    setInitialFemalePlacesTaken(state, initialFemalePlacesTaken) {
        state.initialFemalePlacesTaken = initialFemalePlacesTaken
    },

    setInitialMalePlacesTaken(state, initialMalePlacesTaken) {
        state.initialMalePlacesTaken = initialMalePlacesTaken
    },

    setInitialTotalPlacesTaken(state, initialTotalPlacesTaken) {
        state.initialTotalPlacesTaken = initialTotalPlacesTaken
    },

    setInitialAnswerSelections(state, initialAnswerSelection) {
        state.initialAnswerSelection = initialAnswerSelection
    },

    setRegistrationProp(state, {prop, value, path = null}) {
        if (path === null) {
            set(state.registrationData, prop, value)
        } else {
            set(get(state.registrationData, path), prop, value)
        }
    },

    setFormSelectChoices(state, formSelectChoices) {
        state.formSelectChoices = formSelectChoices
    },

    setOnlineRegistrationFields(state, onlineRegistrationFields) {
        state.onlineRegistrationFields = onlineRegistrationFields
    },

    setRegistrationPerson(state, {person, key}) {
        state.registrationData.persons = {...state.registrationData.persons, [key]: person}
    },

    setCaregiver(state, caregiver) {
        state.caregiver = caregiver
    },

    setCaregiverOptions(state, caregiverOptions) {
        state.caregiverOptions = caregiverOptions
    },

    setEventIsLoaded(state, isLoaded) {
        state.eventIsLoaded = isLoaded
    },

    setPreviewMode(state, previewMode) {
        state.previewMode = previewMode
    },

    initGroupRegistrationCreationMode(state) {
        state.groupRegistrationCreationMode = true
        set(state.registrationData, 'groupRegistrarToken', uuidv4())
        set(state.registrationData, 'groupParticipantToken', uuidv4())
    },

    setCaregiverToken(state, caregiverToken) {
        state.caregiverToken = caregiverToken
    },

    setCaregiverCheckToken(state, caregiverCheckToken) {
        state.caregiverCheckToken = caregiverCheckToken
    },

    setNoCheckToken(state, noCheckToken) {
        state.noCheckToken = noCheckToken
    },

    setGroupRegistrarToken(state, groupRegistrarToken) {
        state.groupRegistrarToken = groupRegistrarToken
    },

    setGroupParticipantToken(state, groupParticipantToken) {
        state.groupParticipantToken = groupParticipantToken
    },

    setStepsValidationState(state, {step, isValid, section}) {
        if (section) {
            if (!state.stepsValidationSections[step]) {
                set(state.stepsValidationSections, step, {})
            }
            set(state.stepsValidationSections[step], section, isValid)
        } else {
            set(state.stepsValidationState, step, isValid)
        }
    },

    setActiveSubPage(state, {parent, index}) {
        set(state.activeSubPage, parent, index)
    },

    setRegistrationFinishedSuccessful(state) {
        state.registrationFinishedSuccessful = true
    },

    setRemoteVersion(state, version) {
        state.remoteVersion = version;
    },

    setTooManyAttempts(state, now) {
        state.tooManyAttemptsAt = now;
    },

    setRetryAfter(state, retryAfter) {
        if(!retryAfter) retryAfter = 0;
        retryAfter += Math.floor(Math.random() * 10 + 1);
        if( retryAfter < 10) retryAfter = 10;
        state.retryAfter = retryAfter;
    }
}
